import { logUsage } from 'owa-analytics';
import { orchestrator } from 'satcheljs';
import { updateFolderPermissionsInStore } from '../actions/publicActions';
import {
    getFolderPermissions,
    getFolderPermissionsSuccess,
    getFolderPermissionsFailed,
} from '../actions/publicActions';
import Folder from 'owa-service/lib/contract/Folder';
import Permission from 'owa-service/lib/contract/Permission';
import getFolderWithAdditionalProperties from '../services/getFolder';
import { trace } from 'owa-trace';
import { getAggregationBucket } from 'owa-analytics-actions';

/**
 * An orchestrator that gets permissions from server if the permissions are not yet fetched.
 * @param actionMessage Object containing folderId
 */
export default orchestrator(getFolderPermissions, async actionMessage => {
    const { folderId } = actionMessage;

    let responseMessage;
    try {
        responseMessage = await getFolderWithAdditionalProperties(folderId, ['PermissionSet']);
    } catch (error) {
        getFolderPermissionsFailed();
        throw error;
    }
    if (responseMessage && responseMessage.ResponseClass == 'Success') {
        const folder: Folder = responseMessage.Folders?.[0];
        // Folder could be null if it's been deleted on the server
        if (folder) {
            const permissions = folder.PermissionSet.Permissions;
            updateFolderPermissionsInStore(folderId, permissions);
            getFolderPermissionsSuccess();
            // Log folder permissions count.
            logFolderPermissions(permissions);
        } else {
            getFolderPermissionsFailed();
            trace.error('Get folder permission server call returned with no matching folders.');
        }
    }
});

/**
 * Log folder permissions count.
 */
function logFolderPermissions(permissions: Permission[]) {
    const permissionsCount = permissions.length;
    logUsage('Triage_FolderPermissions_Load', [getAggregationBucket({ value: permissionsCount })]);
}
